import { generateRandomString } from '../helpers/header';

// API request header
export const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'portalscope': 'b3NMWOVzfdRUjrW',
    'validatereq': generateRandomString(30)
  };
};

// Same auth headers as getHeaders(), without Content-Type so the browser
// can set multipart/form-data with the auto-generated boundary.
export const getMultipartHeaders = () => {
  return {
    'portalscope': 'b3NMWOVzfdRUjrW',
    'validatereq': generateRandomString(30)
  };
};

export const getKonnectHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'scope': 'Kqc73iUdPTF9g3i',
        'validatereq': generateRandomString(25)
    };
};

export { generateRandomString };